import apiFetch from '@wordpress/api-fetch';
import Navigo from 'navigo';
import functions from '../functions';
import '../../scss/hospitality.scss';

const router = new Navigo(null, true, '#!');
const apiUrl = 'https://api.stringerperformance.com/wp-json/wp/v2';
const eventsTemplate = require('../../templates/hospitality/events.handlebars');
const photosTemplate = require('../../templates/hospitality/photos.handlebars');
const sectionTemplate = require('../../templates/hospitality/section.handlebars');

router.on(() => {
  apiFetch({
    url: `${apiUrl}/pages?slug=hospitality`,
  }).then((page) => {
    $('#page-sections').html(sectionTemplate(page[0].acf.page_section));
    $('#sidebar-photos').html(photosTemplate({
      ...page[0].acf,
      title: page[0].acf.section_title,
    }));
  });

  apiFetch({
    url: `${apiUrl}/events?per_page=40`,
  }).then((events) => {
    events.sort((a, b) => {
      const date1 = a.acf.event_dates.split(' ', 2);
      const date2 = b.acf.event_dates.split(' ', 2);
      return Date.parse(`${date1[0]} ${date1[1]}`) - Date.parse(`${date2[0]} ${date2[1]}`);
    });
    const filteredEvents = events.filter((event) => {
      const today = new Date();
      const date1 = event.acf.event_dates.split(' ', 2);
      const date2 = event.acf.event_dates.split(' ', 2);
      const eventDate = new Date(`2022-${date1}-${date2}`);

      return today.getTime() < eventDate.getTime();
    });
    $('#api-content').html(eventsTemplate(filteredEvents.slice(0, 6)));
  });

  functions.initPage();
});

router.resolve();
